import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import apiInstance from '../utils/axios';
import BlinkBtcLogo from '../../media/spendings/Blink_logo_icon.svg';
import BlinkLogoFull from '../../media/spendings/Blink_logo_full_color_white.svg';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import axios from 'axios';
import PaymentStatusPage from './PaymentStatus';
import { REACT_APP_API_BASE_URL } from '../utils/constant';


// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function BlinkAPI() {
  const [btcAmount, setBtcAmount] = useState(""); // in BTC (string)
  const [satsAmount, setSatsAmount] = useState(""); // in sats (string)
  const [eurAmount, setEurAmount] = useState(""); // in EUR (string)

  const [invoice, setInvoice] = useState(''); // TODO change to ''
  const [invoiceId, setInvoiceId] = useState('');
  const [status, setStatus] = useState(null); // TODO change to null

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [btcEur, setBtcEur] = useState(null);

  const { t, i18n } = useTranslation(); // Initialize useTranslation


  const updateAmounts = (value, source) => {
    const btc = value;
    if (btc === "") {
      setSatsAmount("");
      setBtcAmount("");
      setEurAmount("");
      return;
    }

    if (source !== 'btc') {
      setBtcAmount(btc);
    }
    const sats = Math.round(parseFloat(btc) * 1e8);
    setSatsAmount(isNaN(sats) ? "" : sats.toString());
    if (btcEur && source !== 'eur') {
      const eur = parseFloat(btc) * btcEur;
      setEurAmount(isNaN(eur) ? "" : eur.toFixed(2));
    }
  };

  const handleSatsChange = (e) => {
    const sats = e.target.value;
    if (sats === "") {
      setBtcAmount("");
      setEurAmount("");
    }
    setSatsAmount(sats);
    const btcValue = parseInt(sats, 10) / 1e8;
    const btc = isNaN(btcValue) ? "" : btcValue.toFixed(8);
    updateAmounts(btc, 'sats');
  };

  const handleEurChange = (e) => {
    const eur = e.target.value;
    if (eur === "") {
      setBtcAmount("");
      setSatsAmount("");
    } else if (eur && btcEur) {
      const btcValue = parseFloat(eur) / btcEur;
      const formattedBtc = isNaN(btcValue) ? "" : btcValue.toFixed(16);
      updateAmounts(formattedBtc, 'eur');
    }
    setEurAmount(eur);
  };

  const handleBtcChange = (e) => {
    const btc = e.target.value;
    setBtcAmount(btc);
    updateAmounts(btc, 'btc');
  };

  const generateInvoice = async () => {
    setLoading(true);
    setError('');
    setInvoice('');
    try {
      // console.log("BTC AMOUNT: ", btcAmount)
      // console.log("BTC AMOUNT Tyoe: ", typeof btcAmount)
      // Updated endpoint to match the backend URL configuration
      const resp = await axios.post(`${REACT_APP_API_BASE_URL}blink/invoices/`, {
        amount: parseInt(satsAmount, 10),
        description: "Support for Winefacts project"
      });
      // Updated to access payment_request directly from the response
      // The backend now returns: { "payment_request": "lnbc...", "internal_invoice_id": ..., "status": "PENDING" }
      setInvoice(resp.data.payment_request);
      setInvoiceId(resp.data.internal_invoice_id);
      setStatus(resp.data.status.toLowerCase());

    } catch (err) {
      setError(err.response?.data?.error || "Could not generate invoice.");
    }
    setLoading(false);
  };

  const fetchBtcEur = async () => {
      try {
        const res = await axios.get(`${REACT_APP_API_BASE_URL}btc-eur/`); //{ headers: { Authorization: undefined } }
        // const data = await res.json();
        // const price = data.chart.result[0].meta.regularMarketPrice;
        const price = res.data["btc_eur_price"]
        setBtcEur(price);
        // console.log("BTC EUR PRICE: ", price)
      } catch (e) {
        setBtcEur(null);
        console.log("BTC fetch error", e)
      }
    };
  

  useEffect(() => {
    fetchBtcEur();
  }, []);

  return (
    // <div className="blinkapi-section">
    //   <h2>Spend via Lightning</h2>
    //   <span className="blinkapi-title">Blink API</span>

    //   <div className="blinkapi-form">
    //     <label htmlFor="btcAmount" className="blinkapi-label">
    //       Amount (sats): 
    //     </label>
    //     <input
    //       type="number"
    //       id="btcAmount"
    //       value={btcAmount}
    //       onChange={handleAmountChange}
    //       placeholder="e.g., 1000"
    //       className="blinkapi-input"
    //     />
    //     <button 
    //       onClick={generateInvoice} 
    //       disabled={loading || !btcAmount} 
    //       className="btn-primary blinkapi-btn">
    //       {loading ? "Generating..." : "Generate Invoice"}
    //     </button>
    //   </div>
    //   {error && <div style={{ color: 'red', margin: '10px 0' }}>{error}</div>}
    //   {invoice && (
    //     <div style={{ marginTop: '25px', padding: '15px', background: '#f9f9f9', borderRadius: '4px' }}>
    //       <QRCodeSVG value={invoice} size={200} level="H" />
    //       <p style={{ wordBreak: "break-all", fontSize: "0.9em" }}>{invoice}</p>
    //       <a
    //         href={`lightning:${invoice}`}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         style={{ display: "inline-block", marginTop: "1rem", color: "#f7931a", fontWeight: "bold" }}
    //       >
    //         Open in Lightning Wallet
    //       </a>
    //     </div>
    //   )}
    // </div>
    <div className="blinkapi-section">
    <div className="blinkapi-header">
      <img src={BlinkBtcLogo} alt="Blink BTC Logo" className="blinkapi-btc-logo" />
      <h2>{t("spendings.header.lightning")}</h2>
    </div>
    

    <div className="blinkapi-form">
      <label htmlFor="btcAmount" className="blinkapi-label">
        {t("spendings.label.amount")} 
      </label>
      <div className="blinkapi-input-wrapper">
        <input
          type="number"
          id="eurAmount"
          value={eurAmount}
          onChange={handleEurChange}
          placeholder="EUR (e.g., 5.00)"
          className="blinkapi-input"
          min="0"
          step="0.1"

        />
        <span className="blinkapi-input-prefix">EUR</span>
      </div>
      <div className="blinkapi-input-wrapper">
        <input
          type="number"
          id="btcAmount"
          value={satsAmount}
          onChange={handleSatsChange}
          placeholder="sats (e.g., 1000)"
          className="blinkapi-input"
          min="0"
          step="1"
        />
        <span className="blinkapi-input-prefix">sats</span>
      </div>
      <div className="blinkapi-input-wrapper">
        <input
          type="number"
          id="btcAmountBtc"
          value={btcAmount}
          onChange={handleBtcChange}
          placeholder="BTC (e.g., 0.0001)"
          className="blinkapi-input"
          min="0"
          step="0.1"
        />
        <span className="blinkapi-input-prefix">BTC</span>
      </div>
      <button 
        onClick={generateInvoice}
        disabled={loading || !btcAmount} 
        className="btn-primary blinkapi-btn">
        {loading ? "Generating..." : "Generate Invoice"}
      </button>   
    </div>

    <div style={{ margin: "10px 0 20px 0", textAlign: "center" }}>
      {btcEur && (
        <div style={{ color: "#888", fontSize: "1rem" }}>
          <span>BTC/EUR: <b>{btcEur.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</b></span>
        </div>
      )}
    </div>
    
    <div className="blinkapi-title-img">
      <p className="blinkapi-title-img-description">Powered by: </p>
      <img src={BlinkLogoFull} alt="Blink Full Logo" className="blinkapi-full-logo" />
    </div>
    {error && <div style={{ color: 'red', margin: '10px 0' }}>{error}</div>}
    {invoice && (
      <div style={{ marginTop: '25px', padding: '15px', background: '#f9f9f9', borderRadius: '4px' }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <QRCodeSVG value={invoice} size={200} level="H" />
          <p style={{ wordBreak: "break-all", fontSize: "0.9em", marginTop:"10px"}}>{invoice}</p>
          {/* <a
            href={`lightning:${invoice}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: "inline-block", marginTop: "1rem", color: "#f7931a", fontWeight: "bold" }}
          >
            Open in Lightning Wallet
          </a> */}
          <button
            className="btn-primary blinkapi-btn"
            style={{ marginTop: "1rem" }}
            onClick={() => window.open(`lightning:${invoice}`, "_blank", "noopener,noreferrer")}
            type="button"
          >
            Open in Lightning Wallet
          </button>
        </div>
        {status && (
          <PaymentStatusPage invoiceId={invoiceId} status={status} setStatus={setStatus} />
        )}
      </div>
    )}
  </div>
  );
}

export default BlinkAPI;